<template>
    <grey-button
        data-toggle="modal"
        data-target="#helpcenterModal"
        class="pl-3 pr-3"
        style="cursor: pointer; gap: 4px;"
    >
        <i class="fal fa-comment icon-whatsapp"></i>
        <span>Fragen?</span>
    </grey-button>
</template>

<script>
export default {
    name: "ContactButtonMobile",

}
</script>

<style scroped>
.icon-whatsapp {

    color: #36acbb;
}
</style>
